<template>
  <div class="modal modal-filter-details fade" id="modal-notify-managers" role="dialog" aria-labelledby="shortlist-modal-label" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" id="shortlist-modal-label">
            <template>Notify Managers</template>
          </h4>
        </div>
        <div class="modal-body">
          <form class="form-horizontal" @submit.prevent>
            <label class="sr-only">Search for managers</label>
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                placeholder="Manager Name..."
                v-model="search.keywords"/>

              <span class="input-group-btn">
                <ladda-button
                  ref="search"
                  class="btn btn-dark"
                  type="submit"
                  :click="handleSearchManagersCallback">
                  Search
                </ladda-button>
              </span>
            </div>

            <hr />

            <div class="text-center" v-if="haveNoManagersWithoutExisting && notSearching">
              <h5>There are no managers. Try searching to find who you want.</h5>

              <button v-if="haveSearchText" @click="handleClearSearchCallback" class="btn btn-default btn-sm">Clear Search</button>
            </div>
            <ul class="shortlist-modal-results" v-else>
              <li
                v-for="manager in managerWithoutExisting"
                :key="manager.id"
                class="row">
                <div class="col-xs-9 col-sm-10">
                  <div class="details">
                    <p><strong>{{ manager.name }}</strong> - {{ manager.company }}</p>
                  </div>
                </div>
                <div class="col-xs-3 col-sm-2">
                  <a v-if="managerIsAlreadyAdded(manager)" @click="handleRemoveManagerCallback(manager)" class="btn btn-lg btn-success"><i class="fa fa-fw fa-check"></i></a>
                  <a v-else @click="handleAddManagerCallback(manager)" class="btn btn-lg btn-default"><i class="fa fa-fw fa-plus"></i></a>
                </div>
              </li>
            </ul>
          </form>

          <lazy-loading
            scroll-target="#modal-notify-managers .modal-body"
            class="text-center"
            :reached-bottom="getManagersForNextPage"
            ref="lazyLoading">
            <pickstar-loading slot="loading"/>
            <span slot="finished"></span>
          </lazy-loading>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-lg btn-danger pull-left" data-dismiss="modal"><i class="fa fa-close"></i> Cancel</button>
          <ladda-button
            type="button"
            class="btn btn-lg btn-primary"
            :click="handleNotifyManagersCallback">
            <i class="fa fa-check"></i> Notify
          </ladda-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { notify } from 'utils'
import { filter, find, map, findIndex } from 'lodash'
import LazyLoading from 'codium-lazy-loading'
import $ from 'jquery'

export default {
  data () {
    return {
      managersToNotify: [],
      searching: false,
      search: {
        keywords: null,
        status: 'active'
      }
    }
  },

  components: {
    LazyLoading
  },

  computed: {
    ...mapState('booking/request', { booking: 'request' }),
    ...mapState('manager', ['managers']),

    /**
     * Determine if we are not searching.
     *
     * @return bool
     */
    notSearching () {
      return !this.searching
    },

    /**
     * Determine if we have search text.
     *
     * @return bool
     */
    haveSearchText () {
      return this.search.keywords !== null
    },

    /**
     * Determine if we have no talent without the existing talent.
     *
     * @return bool
     */
    haveNoManagersWithoutExisting () {
      return this.managerWithoutExisting.length === 0
    },

    /**
     * Filter out the existing talent against the booking from the search results.
     *
     * @return array
     */
    managerWithoutExisting () {
      return filter(this.managers, (manager) => {
        return find(this.booking.managers_notified, (existing) => existing.id === manager.id) === undefined
      })
    }
  },

  mounted () {
    $(this.$el).on('hidden.bs.modal', () => {
      this.managersToNotify = []
      this.search.keywords = null
    })

    $(this.$el).on('show.bs.modal', () => {
      this.getManagers({ status: 'active' })
    })
  },

  methods: {
    ...mapActions('manager', ['getManagers', 'getManagersForNextPage']),
    ...mapActions('booking/request', ['sendManagerNotifications']),

    /**
     * Determine if a talent already exists within the additional talent array.
     *
     * @return bool
     */
    managerIsAlreadyAdded (manager) {
      return find(this.managersToNotify, added => added.id === manager.id) !== undefined
    },

    /**
     * Handle adding talent to the array of additional talent.
     *
     * @return void
     */
    handleAddManagerCallback (managers) {
      this.managersToNotify.push(managers)
    },

    /**
     * Handle removing talent from the array of additional talent.
     *
     * @return void
     */
    handleRemoveManagerCallback (manager) {
      this.managersToNotify.splice(findIndex(this.managersToNotify, existing => existing.id === manager.id), 1)
    },

    /**
     * Handle clearing the search.
     *
     * @return void
     */
    handleClearSearchCallback () {
      this.search.keywords = null

      this.$refs.search.$el.click()
    },

    /**
     * Handle searching the additional talent.
     *
     * @return Promise
     */
    handleSearchManagersCallback () {
      this.searching = true

      return this.getManagers(this.search)
        .then(() => {
          this.searching = false
        })
    },

    /**
     * Save the selected additional talent against the booking as hidden responses.
     *
     * @return Promise
     */
    handleNotifyManagersCallback () {
      if (this.managersToNotify.length === 0) {
        return Promise.resolve()
      } else {
        let payload = {
          id: this.booking.id,
          payload: {
            managers: map(this.managersToNotify, manager => manager.id)
          }
        }

        return this.sendManagerNotifications(payload)
          .then(() => {
            $(this.$el).modal('hide')
            notify.success('Notified managers')
          })
      }
    }
  }
}
</script>
